import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useDropzone } from "react-dropzone";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function LeadSquare() {
  const [file, setFile] = useState(null);
  const [source, setSource] = useState("");
  const [selectedCourse, setSelectedCourse] = useState('');
  const [leadSource, setLeadSource] = useState('');
  // Handle file drop
  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      setFile(file);
    } else {
      toast.error("Please upload a valid Excel file.");
    }
  };

  // Dropzone settings
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleDrop,
    accept: ".xlsx,.xls",
  });

  // Sequentially send data row-by-row
  const sendDataSequentially = async (jsonData, authToken) => {
    for (const row of jsonData) {
      const raw = JSON.stringify({
        name: row.Name,
        email: row.Email,
        phone: row.Phone,
        course: row.Course,
        campaignName: selectedCourse,
        Source: leadSource,
      });

      const myHeaders = new Headers();
      myHeaders.append("authToken", authToken);
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      try {
        const response = await fetch("https://api.theleadsense.com/api/v1/leadsquare/lead/add", requestOptions);
        if (!response.ok) {
          throw new Error("API error");
        }
        toast.success(`Lead uploaded: ${row.Name}`);
      } catch (error) {
        toast.error(`Failed to upload: ${row.Name}`);
      }
    }
  };

  // Handle file submit
  const handleFileSubmit = () => {
    const authToken = sessionStorage.getItem("Token");

    if (!authToken) {
      toast.error("No authToken found. Please log in again.");
      return;
    }

    if (!file) {
      toast.error("Please upload a file.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);
      console.log(jsonData)

      toast.info("Starting upload...");
      await sendDataSequentially(jsonData, authToken);
      toast.success("All leads processed!");
    };
    reader.readAsBinaryString(file);
  };

  // Download sample template
  const handleDownloadTemplate = () => {
    const sampleData = [
      { Name: "John Doe", Email: "john@example.com", Phone: "1234567890", Course: "MBA" },
      { Name: "Jane Smith", Email: "jane@example.com", Phone: "0987654321", Course: "BBA" },
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads Template");

    XLSX.writeFile(workbook, "Lead_Template.xlsx");
  };

  const courseOptions = [
    { "Value": "" },
    { "Value": "BCA" },
    { "Value": "BBA" },
    { "Value": "BA" },
    { "Value": "Diploma Programs" },
    { "Value": "Certificate Programs" },
    { "Value": "B Com" },
    { "Value": "Certificate Programs In languages" },
    { "Value": "BCOM" },
    { "Value": "BSC" },
    { "Value": "M.COM" },
    { "Value": "MBA" },
    { "Value": "MCA" },
    { "Value": "MSc" },
    { "Value": "MBA Plus" },
    { "Value": "MCA Plus" },
    { "Value": "MBA (1 Year Course)" },
    { "Value": "PGDM" },
    { "Value": "PGPM" },
    { "Value": "GGU" },
    { "Value": "Executive Diploma LIBA" }
  ];
  const leadSources = [
    { "Value": "" },
    { "Value": "Organic Search" },
    { "Value": "Referral Sites" },
    { "Value": "Direct Traffic" },
    { "Value": "Social Media" },
    { "Value": "Inbound Email" },
    { "Value": "Inbound Phone call" },
    { "Value": "Outbound Phone call" },
    { "Value": "Pay per Click Ads" },
    { "Value": "Trade Show" },
    { "Value": "Customer Referral" },
    { "Value": "Partner Referral" },
    { "Value": "Employee Referral" },
    { "Value": "Website" },
    { "Value": "referral" },
    { "Value": "FB Lead Ads" },
    { "Value": "WhatsApp" },
    { "Value": "Chat" },
    { "Value": "Naukri" },
    { "Value": "Big data" },
    { "Value": "META" },
    { "Value": "In house leads" },
    { "Value": "from john sir" },
    { "Value": "Email Sync- Sent Mail" },
    { "Value": "Email Sync- Received Mail" },
    { "Value": "web" },
    { "Value": "Naukri - Chennai" },
    { "Value": "Email Sync" },
    { "Value": "Bitrix" },
    { "Value": "LinkedIn" },
    { "Value": "Push Lead" }


  ];
  const [sroursemetaData, setSourseMetaData] = useState([]); // store 68 objects here
  const [ProgramsmetaData, setProgramsMetaData] = useState([]); // store 68 objects here
  console.log(sroursemetaData)

  useEffect(() => {
    const fetchMetaData = async () => {
      try {
        const response = await fetch(
          "https://api-in21.leadsquared.com/v2/LeadManagement.svc/LeadsMetaData.Get?accessKey=u$r1d64e7e490a71e5105cf6a1a3efcd1fe&secretKey=48390d57d17254e36ee25ca1b12517e5b28e1355",
          { method: "GET", redirect: "follow" }
        );
        const result = await response.json(); // <-- parse JSON
        setSourseMetaData(result[67].Options); // store 68 objects in state
        setProgramsMetaData(result[6].Options)
      } catch (error) {
        console.error("Error fetching metadata:", error);
      }
    };

    fetchMetaData();
  }, []);
  return (
    <div className="row">
      <div className="col-lg-12">
        <h1>Upload Lead</h1>
      </div>
      <div className="col-lg-12">
        <div className="card" style={{ padding: "30px" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5" style={{ float: "right" }}>
                <button onClick={handleDownloadTemplate}>Download Template</button>
              </div>
            </div>
            <div className="col-lg-12">
              <div
                {...getRootProps()}
                style={{
                  border: "2px dashed #ccc",
                  padding: "20px",
                  textAlign: "center",
                  cursor: "pointer",
                }}
              >
                <input {...getInputProps()} />
                <p>Drag & Drop your Excel file here, or click to select</p>
                <h5>{file?.name}</h5>
              </div>
            </div>
            <div className="col-lg-4">
              <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <label>Enter Campaign Name</label>
                <select
                  className="form-control"
                  value={selectedCourse}
                  onChange={(e) => setSelectedCourse(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  {ProgramsmetaData.map((course, index) => (
                    <option key={index} value={course.Value}>
                      {course.Value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-4">
              <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <label>Select Lead Source</label>
                <select
                  className="form-control"
                  value={leadSource}
                  onChange={(e) => setLeadSource(e.target.value)}
                >
                  <option value="">-- Select Lead Source --</option>
                  {sroursemetaData.map((source, index) => (
                    <option key={index} value={source.Value}>
                      {source.Value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-4">
              <button
                onClick={handleFileSubmit}
                style={{ marginTop: "35px", marginBottom: "20px" }}
              >
                Upload and Send to API
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
}

export default LeadSquare;
